var exports = {
  "kL": "xfd349460--1a074b--container",
  "Sl": "xfd349460--1a074b--image",
  "DD": "xfd349460--1a074b--title",
  "h_": "xfd349460--1a074b--description",
};

module.exports = exports;
